import { createReducer, on } from '@ngrx/store';

import { cropYearChanged } from '../../../../store/actions';
import {
  loadSoilAnalysisSuccess,
  setBlightLayerEnabled,
  setCropFieldsLayerEnabled,
  setSoilAnalysesLayerEnabled,
  upsertFeatures,
} from './map.actions';
import { MapState } from '../map.models';

export const initialMapState: MapState = {
  soilAnalysisLayerEnabled: false,
  cropFieldsLayerEnabled: true,
  blightLayerEnabled: false,
};

export const mapReducer = createReducer(
  initialMapState,

  on(cropYearChanged, (state): MapState => ({
    ...state,
    features: [],
    soilAnalysis: [],
  })),

  on(loadSoilAnalysisSuccess, (state, { payload: { soilAnalyses } }): MapState => ({
    ...state,
    soilAnalysis: soilAnalyses,
  })),

  on(upsertFeatures, (state, { features }): MapState => ({
    ...state,
    features: features,
  })),

  on(setSoilAnalysesLayerEnabled, (state, { enabled }): MapState => ({
    ...state,
    soilAnalysisLayerEnabled: enabled,
  })),

  on(setBlightLayerEnabled, (state, { enabled }): MapState => ({
    ...state,
    blightLayerEnabled: enabled,
  })),

  on(setCropFieldsLayerEnabled, (state, { enabled }): MapState => ({
    ...state,
    cropFieldsLayerEnabled: enabled,
  })),
)
